import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { HeartOutlined, AimOutlined, BulbOutlined } from '@ant-design/icons';
import NET from 'vanta/dist/vanta.net.min';
import * as THREE from 'three';
import './About.scss';

const About: React.FC = () => {
  const { t } = useTranslation();
  const vantaRef = useRef<HTMLDivElement | null>(null);
  const vantaEffect = useRef<any>(null);

  useEffect(() => {
    if (!vantaRef.current || vantaEffect.current) {
      return;
    }

    try {
      vantaEffect.current = NET({
        el: vantaRef.current,
        THREE: THREE,
        mouseControls: true,
        touchControls: true,
        gyroControls: false,
        minHeight: 200.00,
        minWidth: 200.00,
        scale: 1.00,
        scaleMobile: 1.00,
        color: 0x69c0ff,
        backgroundColor: 0x001529,
        points: 10,
        maxDistance: 20,
        spacing: 15,
        showDots: true,
      });
    } catch (error) {
      console.error('Vanta initialization error:', error);
    }

    return () => {
      if (vantaEffect.current) {
        vantaEffect.current.destroy();
        vantaEffect.current = null;
      }
    };
  }, []);

  return (
    <div className="about-page">
      <div className="about-vanta-bg" ref={vantaRef}></div>
      <div className="about-content">
      <section className="about-hero">
        <h1>{t('about')}</h1>
        <h2 className="about-title">
          <HeartOutlined className="about-title-icon" />
          {t('introductionLetterTitle')}
        </h2>
        <p>{t('introductionLetterContent')}</p>
      </section>

      <section className="about-grid">
        <div className="about-section">
          <h2 className="about-title">
            <AimOutlined className="about-title-icon" />
            {t('visionMissionTitle')}
          </h2>
          <p>{t('visionMissionContent')}</p>
        </div>
      </section>

      <section className="about-section">
        <h2 className="about-title">
          <BulbOutlined className="about-title-icon" />
          {t('directionsTitle')}
        </h2>
        <ul className="about-list">
          {(t('directions', { returnObjects: true }) as string[]).map((direction: string, index: number) => (
            <li key={index}>{direction}</li>
          ))}
        </ul>
      </section>
      </div>
    </div>
  );
};

export default About;